import React, { useEffect, useState } from "react";
import {
	// useHistory,
	useNavigate,
	useParams,
} from "react-router-dom";

// COMPS
import { CircularProgress } from "@material-ui/core";
// STYLES
import { PageWrapper } from "./EmailVerification.style";
import { ReactComponent as HeaderLogo } from "../../../Assets/Images/LandingPage/subjects-master-logo.svg";

import { Api, URL_LOGIN } from "Helpers";

function ForgotPassword(props) {
	let [isLoading, setIsLoading] = useState(true),
		[isSuccess, setSuccess] = useState(false),
		// The same link verifies Classroom Pilot applications, which have no account to log in to.
		[isPilotApplication, setIsPilotApplication] = useState(false),
		[hasFailed, setHasFailed] = useState(false);

	// ROUTER
	// let history = useHistory();
	const navigate = useNavigate();
	let { token } = useParams();

	useEffect(registerAccount, []);

	function registerAccount() {
		let data = new FormData();
		data.append("emailVerificationToken", token);

		new Api()
			.post("user/verificationToken ", { data, skipErrorHandling: true })
			.then((response) => {
				setIsLoading(false);

				// An invalid or expired link used to fall through to "Account Activated!".
				if (response?.status !== 200) {
					setHasFailed(true);
					return;
				}

				setSuccess(true);

				if (response?.data?.isPilotApplication) {
					setIsPilotApplication(true);
					return;
				}

				setTimeout(() => {
					navigate(URL_LOGIN);
				}, 1000);
			})
			.catch(() => {
				setIsLoading(false);
				setHasFailed(true);
			});
	}

	function getTitle() {
		if (hasFailed) return "Verification Failed";
		if (isPilotApplication) return "Email Verified!";
		return isSuccess ? "Account Activated!" : "Just a Second...";
	}

	function getMessage() {
		if (hasFailed) return "This verification link is invalid or has expired.";
		if (isPilotApplication) return "Thank you. Your email address is verified, and our team will be in touch about your Classroom Pilot application.";
		return isSuccess ? "Your account has been successfully activated." : "We are preparing your shiny new account.";
	}

	return (
		<PageWrapper>
			<div className="PageWrapper">
				<div className="verification-container">
					<div className="verification-box">
						<div className="emailverification-logo">
							<HeaderLogo />
						</div>

						<div className={`icon-wrapper ${isSuccess ? "success" : ""}`}>{isSuccess ? "✔" : hasFailed ? "✖" : "⏳"}</div>
						<div className="content">
							<h2 className="title">{getTitle()}</h2>
							<p className="message">{getMessage()}</p>
							{isLoading && (
								<div className="progress">
									<CircularProgress color="secondary" size={30} />
								</div>
							)}
						</div>
					</div>
				</div>
			</div>

		</PageWrapper>
	);
}

export default ForgotPassword;
